import React, { useEffect } from "react";
import EdiText from "react-editext";
import { connect, useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import {
  getHostProfile,
  disableHost,
  updateHostCoin,
} from "../store/host/host.action";
import { deleteUser } from "../store/user/user.action";
import { setToast } from "../util/toast";
import { warning } from "../util/Alert";
import { baseURL } from "../util/config";

import femaleImage from "../assets/img/female.png";
import maleImage from "../assets/img/maleImage.png";

const HostProflie = (props) => {
  const dispatch = useDispatch();
  const { hostProfile } = useSelector((state) => state.host);
  const location = useLocation();
  const history = useHistory();

  const hostId = location?.state?.hostId || sessionStorage.getItem("hostId");

  useEffect(() => {
    if (hostId) {
      dispatch(getHostProfile(hostId));
    }
  }, [dispatch, hostId]);

  const handlePreviousPage = () => {
    history.goBack();
  };

  const handleClick = (host) => {
    props.disableHost(host);
  };

  const handleOpenImage = (url) => {
    if (url) {
      window.open(url, "_blank");
    }
  };

  const handleHistory = () => {
    if (hostId) {
      sessionStorage.setItem("hostId", hostId);
      history.push({
        pathname: "/admin/host/history",
        state: { hostId },
      });
    }
  };

  const handleDelete = () => {
    const data = warning();
    data
      .then((isDeleted) => {
        if (isDeleted) {
          props.deleteUser(hostProfile?._id || hostId);
          history.goBack();
        }
      })
      .catch((err) => console.log(err));
  };

  const handleSave = (val) => {
    if (val < 0) {
      setToast("error", "Invalid Coin");
    } else {
      const coinValid = isNumeric(val);
      if (!coinValid) {
        setToast("error", "Invalid Coin");
      } else {
        props.updateHostCoin(val, hostProfile._id);
      }
    }
  };

  const isNumeric = (value) => {
    const val = value === "" ? 0 : value;
    return /^\d+$/.test(val);
  };

  const getImageSrc = () => {
    const img = hostProfile?.image;
    if (
      img &&
      !img.includes("male.png") &&
      !img.includes("female.png") &&
      !img.includes("noImage.png")
    ) {
      return img.startsWith("http") ? img : baseURL + img;
    }
    return hostProfile?.gender?.toLowerCase() === "male" ? maleImage : femaleImage;
  };

  return (
    <>
      <div className="row justify-content-between align-items-center mb-2">
        <h4 className="ml-3 font-weight-bold">
          {hostProfile?.name ? `${hostProfile.name}'s Profile` : "Host Profile"}
        </h4>
        <div className="userBtn">
          {!hostProfile?.isFake && (
            <button
              className="btn btn-success mr-2"
              onClick={handleHistory}
              title="View History"
            >
              <i className="fa fa-history"></i>
            </button>
          )}
          <button
            className="btn btn-danger mr-2"
            onClick={handleDelete}
            title="Delete Host"
          >
            <i className="fa fa-trash"></i>
          </button>
          <button
            className="btn btn-primary"
            style={{ marginRight: "15px" }}
            onClick={handlePreviousPage}
            title="Back"
          >
            <i className="fa-solid fa-angles-left"></i>
          </button>
        </div>
      </div>

      {/* Main Profile Info Card */}
      <div className="card mt-4">
        <div className="card-body">
          <div className="row align-items-center">
            <div className="col-sm-12 col-md-6 col-lg-3 col-xxl-3 col-xl-3 text-center">
              <img
                src={getImageSrc()}
                draggable="false"
                className="mx-auto image img-thumbnail shadow-sm"
                style={{
                  width: "240px",
                  height: "240px",
                  objectFit: "cover",
                  display: "block",
                  borderRadius: "50%",
                  cursor: "pointer",
                  border: "3px solid #ff4d88",
                }}
                alt="hostProfile"
                onClick={() => handleOpenImage(hostProfile?.image)}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src =
                    hostProfile?.gender?.toLowerCase() === "male"
                      ? maleImage
                      : femaleImage;
                }}
              />
              <div className="mt-3">
                <span className="badge badge-warning text-dark font-weight-bold px-3 py-1 mr-1">
                  HOST
                </span>
                {hostProfile?.isFake ? (
                  <span className="badge badge-secondary px-2 py-1">Fake Host</span>
                ) : (
                  <span className="badge badge-success px-2 py-1">Real Host</span>
                )}
              </div>
            </div>

            <div className="col-sm-12 col-md-6 col-lg-9 col-xxl-9 col-xl-9 pl-md-4 pl-lg-5">
              <div className="row">
                <table className="w-100 userTable" style={{ fontSize: "15px" }}>
                  <tbody>
                    <tr className="border-bottom">
                      <td width="110px" className="py-3 text-profile">
                        Name
                      </td>
                      <td width="40px" className="text-white">
                        :
                      </td>
                      <td className="text-white font-weight-bold">
                        {hostProfile?.name || "-"}
                      </td>
                    </tr>

                    <tr className="border-bottom">
                      <td width="110px" className="py-3 text-profile">
                        Unique ID
                      </td>
                      <td width="40px" className="text-white">
                        :
                      </td>
                      <td className="text-white">
                        <span className="badge badge-info px-2 py-1 font-weight-bold">
                          {hostProfile?.uniqueID || hostProfile?.uniqueId || hostProfile?._id || "N/A"}
                        </span>
                      </td>
                    </tr>

                    <tr className="border-bottom">
                      <td width="110px" className="py-3 text-profile">
                        Email
                      </td>
                      <td width="40px" className="text-white">
                        :
                      </td>
                      <td className="text-white">
                        {!hostProfile?.email ||
                        hostProfile.email.toLowerCase() === "flirtzy@gmail.com" ||
                        hostProfile.email.toLowerCase() === "support@flirtzy.tech"
                          ? "N/A"
                          : hostProfile.email}
                      </td>
                    </tr>

                    <tr className="border-bottom">
                      <td width="110px" className="py-3 text-profile">
                        Bio
                      </td>
                      <td width="40px" className="text-white">
                        :
                      </td>
                      <td className="text-white">{hostProfile?.bio || "-"}</td>
                    </tr>

                    <tr className="border-bottom">
                      <td width="110px" className="py-3 text-profile">
                        Gender
                      </td>
                      <td width="40px" className="text-white">
                        :
                      </td>
                      <td className="text-white">
                        <span className="text-capitalize">{hostProfile?.gender || "-"}</span>
                      </td>
                    </tr>

                    <tr className="border-bottom">
                      <td width="110px" className="py-3 text-profile">
                        DOB
                      </td>
                      <td width="40px" className="text-white">
                        :
                      </td>
                      <td className="text-white">{hostProfile?.dob || "-"}</td>
                    </tr>

                    <tr className="border-bottom">
                      <td width="110px" className="py-3 text-profile">
                        Age
                      </td>
                      <td width="40px" className="text-white">
                        :
                      </td>
                      <td className="text-white">{hostProfile?.age || "-"}</td>
                    </tr>

                    <tr className="border-bottom">
                      <td width="110px" className="py-3 text-profile">
                        Interest In
                      </td>
                      <td width="40px" className="text-white">
                        :
                      </td>
                      <td className="text-white">{hostProfile?.interestIn || "-"}</td>
                    </tr>

                    <tr>
                      <td width="110px" className="py-3 text-profile">
                        Reg. Date
                      </td>
                      <td width="40px" className="text-white">
                        :
                      </td>
                      <td className="text-white">
                        {hostProfile?.date ||
                          (hostProfile?.createdAt
                            ? new Date(hostProfile.createdAt).toLocaleDateString()
                            : "-")}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Details Row (2 Columns) */}
      <div className="row mt-4">
        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-3">
          <div className="card h-100">
            <div className="card-body px-4 py-3">
              <table className="w-100" style={{ fontSize: "15px" }}>
                <tbody>
                  <tr className="border-bottom">
                    <td width="120px" className="py-3 text-profile">
                      Status
                    </td>
                    <td width="40px" className="text-white">
                      :
                    </td>
                    <td className="text-white">
                      {hostProfile?.isOnline ? (
                        <span className="badge badge-success px-2 py-1"> Online </span>
                      ) : (
                        <span className="badge badge-danger px-2 py-1"> Offline </span>
                      )}
                    </td>
                  </tr>

                  <tr className="border-bottom">
                    <td width="120px" className="py-3 text-profile">
                      Coin Balance
                    </td>
                    <td width="40px" className="text-white">
                      :
                    </td>
                    <td className="text-white">
                      {!hostProfile?.isFake ? (
                        <EdiText
                          type="text"
                          value={hostProfile?.coin || 0}
                          onSave={handleSave}
                        />
                      ) : (
                        <span>{hostProfile?.coin || 0}</span>
                      )}
                    </td>
                  </tr>

                  <tr className="border-bottom">
                    <td width="120px" className="py-3 text-profile">
                      Mobile No
                    </td>
                    <td width="40px" className="text-white">
                      :
                    </td>
                    <td className="text-white">
                      {hostProfile?.mobileNumber ? hostProfile.mobileNumber : "-"}
                    </td>
                  </tr>

                  <tr className="border-bottom">
                    <td width="120px" className="py-3 text-profile">
                      Country
                    </td>
                    <td width="40px" className="text-white">
                      :
                    </td>
                    <td className="text-white">{hostProfile?.country || "-"}</td>
                  </tr>

                  <tr>
                    <td width="120px" className="py-3 text-profile">
                      Identity
                    </td>
                    <td width="40px" className="text-white">
                      :
                    </td>
                    <td className="text-white font-italic text-muted">
                      {hostProfile?.identity || "-"}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-3">
          <div className="card h-100">
            <div className="card-body px-4 py-3">
              <table className="w-100" style={{ fontSize: "15px" }}>
                <tbody>
                  <tr className="border-bottom">
                    <td width="130px" className="py-3 text-profile">
                      Block / Disable
                    </td>
                    <td width="40px" className="text-white">
                      :
                    </td>
                    <td className="text-white">
                      <label className="switch s-icons s-outline s-outline-primary mb-0">
                        <input
                          type="checkbox"
                          checked={hostProfile?.isBlock || false}
                          onChange={() => handleClick(hostProfile)}
                        />
                        <span className="slider round"></span>
                      </label>
                      <span className="ml-2 text-muted" style={{ fontSize: "13px" }}>
                        {hostProfile?.isBlock ? "Blocked" : "Active"}
                      </span>
                    </td>
                  </tr>

                  <tr className="border-bottom">
                    <td width="130px" className="py-3 text-profile">
                      Platform Type
                    </td>
                    <td width="40px" className="text-white">
                      :
                    </td>
                    <td className="text-white">
                      {hostProfile?.platformType === 0 ? "Android" : "iOS"}
                    </td>
                  </tr>

                  <tr className="border-bottom">
                    <td width="130px" className="py-3 text-profile">
                      Login Type
                    </td>
                    <td width="40px" className="text-white">
                      :
                    </td>
                    <td className="text-white">
                      {hostProfile?.LoginType === 0 ? "Email" : "Quick Login"}
                    </td>
                  </tr>

                  <tr className="border-bottom">
                    <td width="130px" className="py-3 text-profile">
                      Email Verified
                    </td>
                    <td width="40px" className="text-white">
                      :
                    </td>
                    <td className="text-white">
                      {hostProfile?.isEmailVerified ? (
                        <span className="badge badge-success">Yes</span>
                      ) : (
                        <span className="badge badge-secondary">No</span>
                      )}
                    </td>
                  </tr>

                  <tr className="border-bottom">
                    <td width="130px" className="py-3 text-profile">
                      Phone Verified
                    </td>
                    <td width="40px" className="text-white">
                      :
                    </td>
                    <td className="text-white">
                      {hostProfile?.isPhoneVerified ? (
                        <span className="badge badge-success">Yes</span>
                      ) : (
                        <span className="badge badge-secondary">No</span>
                      )}
                    </td>
                  </tr>

                  <tr>
                    <td width="130px" className="py-3 text-profile">
                      Last Login
                    </td>
                    <td width="40px" className="text-white">
                      :
                    </td>
                    <td className="text-white">{hostProfile?.lastLogin || "-"}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* Host Album Photos Card */}
      <div className="card mt-4 mb-4">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h5 className="card-title text-white mb-0">
            <i className="fa fa-images mr-2 text-primary"></i> Host Album Photos (
            {hostProfile?.album?.length || 0})
          </h5>
        </div>
        <div className="card-body">
          {hostProfile?.album && hostProfile.album.length > 0 ? (
            <div className="row">
              {hostProfile.album.map((image, index) => (
                <div key={index} className="col-6 col-sm-4 col-md-3 col-lg-2 mb-3">
                  <div
                    style={{
                      borderRadius: "12px",
                      overflow: "hidden",
                      border: "1px solid #3b3f5c",
                      backgroundColor: "#1f1c30",
                      cursor: "pointer",
                      aspectRatio: "1 / 1",
                      position: "relative",
                    }}
                    onClick={() => handleOpenImage(image)}
                    title="Click to view full image"
                  >
                    <img
                      src={image}
                      alt={`album-${index}`}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        transition: "transform 0.2s ease",
                      }}
                      className="img-fluid zoom"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = femaleImage;
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-4 text-muted">
              <i className="fa fa-image fa-2x mb-2 d-block"></i>
              No album photos uploaded yet.
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default connect(null, {
  getHostProfile,
  disableHost,
  updateHostCoin,
  deleteUser,
})(HostProflie);
